// SpaPriorityTier moved to quotes/enums so the saved-config types (quotes/types)
// can reference it without a types -> component import. Re-exported here so the
// drawer's existing relative imports keep working.
export { SpaPriorityTier } from 'quotes/enums';

export enum ExportSkuPartStep {
  FORM = 'form',
  PREVIEW = 'preview',
}

// Sentinel id backing the "All Customers" option prepended to the customer
// autocomplete. Negative so it never collides with a real contact group address id.
export const ALL_CUSTOMERS_OPTION_ID = -1;

// Sentinel id backing the "All Locations" option prepended to the sales-location
// autocomplete. Negative so it never collides with a real corporate location id.
export const ALL_SALES_LOCATIONS_OPTION_ID = -2;
